<template>
  <b-taglist>
    <div v-for="set in screen_sets">
      <b-tag>{{ set.name }}</b-tag>
    </div>
  </b-taglist>
</template>

<script>
  export default {
    data() {
      return {}
    },
    props: {
      personas: Array,
      screen_sets: Array,
    },
    components: {},
    methods: {},
    computed: {

    },
    created: function() {},
  }
</script>

<style lang="scss">

</style>
